export enum ViewType {
  Default,
  FloorPlan,
}
